// extracted by mini-css-extract-plugin
module.exports = {"statusItem":"TimesheetStatusItem_statusItem__A4B6-","errorMessage":"TimesheetStatusItem_errorMessage__1a53o"};